import classNames from 'classnames';
import React from 'react';
import { TextareaProps } from './types';

const Textarea: React.FC<TextareaProps> = ({
  label,
  name,
  id,
  value,
  autoComplete,
  disabled,
  placeholder,
  error,
  required,
  onChange,
  register,
  validation
}: TextareaProps) => {
  const inputClasses = classNames(
    'bg-rt-input border border-white border-opacity-30 p-4 text-white w-full appearance-none rounded-none',
    {}
  );

  const validationRules = validation || {};

  return (
    <div className="mb-3">
      {label ? (
        <label className="text-white mb-2 block text-sm" htmlFor={id}>
          {label}
        </label>
      ) : null}
      <textarea
        {...register(id, { required, ...validationRules })}
        className={inputClasses}
        aria-describedby={error ? `${name}-error` : undefined}
        aria-invalid={!!error}
        placeholder={placeholder}
        disabled={disabled}
        id={id}
        name={name}
        autoComplete={autoComplete}
        defaultValue={value}
        onChange={onChange}
        rows={4}
      />
      {error ? (
        <span role="alert" className="text-sm text-red-500" id={`${name}-error`}>
          {error}
        </span>
      ) : null}
    </div>
  );
};

export default Textarea;
